(() => {
  const initUspBar = () => {
    const uspBar = document.querySelector(".js-usp-bar");
    if (!uspBar) return;

    const messages = document.querySelectorAll(".js-usp-bar-message");
    let currentIndex = 0;
    const interval = parseInt(uspBar.dataset.interval, 10) || 5000;

    const showNextMessage = () => {
      const currentMessage = messages[currentIndex];
      currentMessage.classList.remove("usp-bar__message--visible");
      currentMessage.classList.add("usp-bar__message--fade-out");

      setTimeout(() => {
        currentMessage.classList.remove("usp-bar__message--fade-out");
        currentIndex = (currentIndex + 1) % messages.length;
        messages[currentIndex].classList.add("usp-bar__message--visible");
      }, 1000);
    };

    messages[currentIndex].classList.add("usp-bar__message--visible");

    setInterval(showNextMessage, interval);
  };

  if (window.innerWidth < 1024) {
    initUspBar();
  }
})();
